import React from 'react';

// About page motive section 
const AboutMotive = () => {
    return (
        <div className='container mt-5 bg-dark text-white p-4'>
            <h2 className='text-center'>Created to help you live a better, <br /> happier, healthier life.</h2>
            <p className='text-center mt-3'>
                We believe fitness should be accessible to everyone, everywhere, regardless of income level or access to  a gym. That's why we offer hundreds of free, full-length workout videos, the most affordable and effective workout programs on the web, meal plans, and helpful health, nutrition and fitness information.
            </p>
        </div>
    );
};

export default AboutMotive;